import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  AllowedStrandGuard,
  AuthenticationGuard,
  CompleteProfileGuard,
  CoupledTeacherGuard,
  DashboardGuard,
  LicenseGuard,
  MissingLearnerProfileGuard,
  PermissionGuard,
  RedirectGuard,
  RedirectV2Guard,
  TermPrivacyGuard,
  YearTransitionGuard,
} from './can-activate';
@NgModule({
  imports: [CommonModule],
  providers: [
    CoupledTeacherGuard,
    AuthenticationGuard,
    PermissionGuard,
    TermPrivacyGuard,
    AllowedStrandGuard,
    DashboardGuard,
    CompleteProfileGuard,
    LicenseGuard,
    YearTransitionGuard,
    MissingLearnerProfileGuard,
    RedirectGuard,
    RedirectV2Guard,
  ],
})
export class GuardsModule {}
